import Vue from 'vue';
import { mapState } from 'vuex';

import platform from 'platform';

Vue.mixin({
  data: () => ({

  }),
  computed: {
    $_isMobile() {
      return ['iOS', 'Android'].includes(platform.os.family);
    },
    $_isFullscreen() {
      return window.innerWidth < 1264;
    },
    ...mapState({
      $_myUserData: state => state.userData
    })
  },
  methods: {
    $_createPageTitle(meta) {
      const title = meta.title || 'midies';
      const desc = typeof meta.desc !== 'undefined' ? meta.desc : 'MIDIデバイスを使って音楽を配信できるサービスです。';
      document.title = title;
      const descMetaTag = document.querySelector('meta[name="description"]');
      if (descMetaTag) {
        descMetaTag.setAttribute('content', desc);
      }
      const ogUrlMetaTag = document.querySelector('meta[property="og:url"]');
      if (ogUrlMetaTag) {
        ogUrlMetaTag.setAttribute('content', 'https://midies.web.app' + this.$route.path);
      }
      const ogTypeMetaTag = document.querySelector('meta[property="og:type"]');
      if (ogTypeMetaTag) {
        ogTypeMetaTag.setAttribute('content', this.$route.name === 'home' ? 'website' : 'article');
      }
      const ogTitleMetaTag = document.querySelector('meta[property="og:title"]');
      if (ogTitleMetaTag) {
        ogTitleMetaTag.setAttribute('content', title);
      }
      const ogDescMetaTag = document.querySelector('meta[property="og:description"]');
      if (ogDescMetaTag) {
        ogDescMetaTag.setAttribute('content', desc);
      }
    },
    $_musicalInstruments() {
      const state = this.$store.state.soundData;
      const returnState = {};
      const selects = [];
      for (const soundId in state) {
        selects.push({
          text: state[soundId].text,
          value: soundId
        });
        returnState[soundId] = {
          ...state[soundId],
          isLoaded: state[soundId].sounds.size === 88
        };
      }
      return {
        info: {
          ...returnState
        },
        selects
      };
    },
    $_sleep(msec) {
      return new Promise(resolve => setTimeout(resolve, msec));
    },
    $_pushNotice(text, type, icon, group = 'app') {
      this.$notify({
        group,
        text,
        type,
        duration: 5000,
        data: { icon }
      });
    },
    async $_getNtpTimeDiff() {
      const nowTime = Date.now();
      const ntpTime = await fetch('https://ntp-a1.nict.go.jp/cgi-bin/json')
        .then(res => res.json())
        .then(json => json.st)
        .catch(() => undefined);
      if (ntpTime) {
        return ntpTime*1000 - nowTime - Math.round((nowTime - Date.now())/2);
      } else {
        return undefined;
      }
    },
    $_getNowTime(diffTime = 0) {
      return Date.now() + diffTime;
    },
    $_convertNumFormat(num) {
      if (!num) {
        return 0;
      } else if (num < 10000) {
        return num.toLocaleString();
      }
      const formatNum = String(num).slice(0, -3);
      return formatNum[0] + '.' + formatNum[1] + '万';
    },
    $_convertDateFormat(date, time = false) {
      if (!date) {
        return undefined;
      } else if (typeof date !== 'object') {
        date = new Date(date);
      }
      const dateFormat = date.getFullYear() + '/' +
             ('0' + (date.getMonth() + 1)).slice(-2) + '/' +
             ('0' + date.getDate()).slice(-2);
      if (time) {
        const timeFormat = ('0' + date.getHours()).slice(-2) + ':' +
               ('0' + date.getMinutes()).slice(-2);
        return dateFormat + ' ' + timeFormat;
      } else {
        return dateFormat;
      }
    },
    $_convertPlayTime(time) {
      if (isNaN(time)) {
        return '00:00';
      }
      const timeFormat = {
        hour: ('0' + Math.floor(time/(60*60*1000))).slice(-2),
        min: ('0' + Math.floor(time/(60*1000)%60)).slice(-2),
        sec: ('0' + Math.floor(time/1000%60)).slice(-2)
      };
      if (timeFormat.hour !== '00') {
        return `${timeFormat.hour}:${timeFormat.min}:${timeFormat.sec}`;
      }
      return `${timeFormat.min}:${timeFormat.sec}`;
    },
    $_beforeunloadHandler(e) {
      e.returnValue = '接続が解除されます。\nページを離れますか？';
    }
  }
});
